import Footer from "../../components/Footer";
import Introduction from "../../components/Introduction";
import Navbar from "../../components/Navbar";
import useFetch from "../../hooks/useFetch";
import config from "../../config";
import DefaultPage from "../DefaultPage/DefaultPage";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import "./EducationProgramPage.css";
import Loader from "../../components/Loader";
import EducationProgramField from "./EducationProgramField";

const EducationProgramPage = (props) => {
  //fetch stranky, populate na programy s rozvrhem hodin a modalni okno k zapisu
  let url = `${config.api}/api/${props.education}`;
  if (props.education === "after-school-club-page") {
    url += `?populate[fields][populate]=*&populate[background][populate]=*`;
  } else if (props.education === "primary-school-page") {
    url += `?populate[fields][populate]=*&populate[background][populate]=*`;
  }
  //fetch stranky, populate na programy s rozvrhem hodin a modalni okno k zapisu
  const { loading, error, data } = useFetch(url);
  //prettier-ignore
  if (loading) return <Loader />;
  //prettier-ignore
  if (error) return <DefaultPage message="Chyba při načítání vzdělávacího institutu" />;
  //prettier-ignore
  if (!data || !data.data) return <DefaultPage message="Žádné data na stránce" />;

  //? test
  console.log(data.data);

  //změna titulku stránky v prohlížeči
  document.title = data.data.title;

  return (
    <div className="min-height-100 d-flex flex-column container-fluid background-white">
      <Navbar />
      <Introduction
        title={data.data.title}
        text={data.data.description}
        image={data.data.background.url}
      />
      <div className="container-fluid background-white">
        <div className="container container-background p-4 p-md-5">
          {/* kontrola jestli je text array a jestli neni null */}
          <BlocksRenderer
            content={Array.isArray(data?.data?.text) ? data.data.text : []}
            blocks={{
              image: ({ image }) => (
                <img
                  src={image.url}
                  alt={image.alternativeText}
                  className="blocks-renderer-img"
                />
              ),
              list: ({ children, format }) =>
                format === "unordered" ? (
                  <ul className="blocks-renderer-ul">{children}</ul>
                ) : (
                  <ol className="blocks-renderer-ol">{children}</ol>
                ),
            }}
          ></BlocksRenderer>

          {data.data?.fields && (
            <div className="study-field-container">
              {data.data?.fields?.map((field) => (
                <EducationProgramField field={field} />
              ))}
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default EducationProgramPage;
